$(document).ready(function () {
    const $dropzone = $('#order_dropzone');
    const $input = $('#order_file_input');
    const $fileNames = $('#file_names_for_order');
    if (!$dropzone.length || !$input.length || !$fileNames.length) return;

    let selectedFiles = [];
    $input.val('');

    $input.on('change', function () {
        selectedFiles = Array.from(this.files);
        renderFileLabels();
    });

    $dropzone.on('dragover', function (e) {
        e.preventDefault();
        $dropzone.addClass('highlight');
    });

    $dropzone.on('dragleave', function () {
        $dropzone.removeClass('highlight');
    });

    $dropzone.on('drop', function (e) {
        e.preventDefault();
        $dropzone.removeClass('highlight');

        const droppedFiles = Array.from(e.originalEvent.dataTransfer.files);
        selectedFiles = selectedFiles.concat(droppedFiles);
        renderFileLabels();
    });

    function renderFileLabels() {
        $fileNames.empty();

        if (selectedFiles.length === 0) {
            $fileNames.html('<div class="item" style="color: grey;">ファイルが選択されていません</div>');
        } else {
            selectedFiles.forEach((file, index) => {
                const $label = $('<div>', {
                    class: 'ui label',
                    css: { margin: '4px' },
                    text: file.name
                });

                const $closeIcon = $('<i>', {
                    class: 'delete icon',
                    css: { cursor: 'pointer' },
                    click: function () {
                        selectedFiles.splice(index, 1);
                        renderFileLabels();
                    }
                });

                $label.append($closeIcon);
                $fileNames.append($label);
            });
        }

        updateInputFiles();
    }

    // `<input>`要素の更新
    function updateInputFiles() {
        const dataTransfer = new DataTransfer();
        selectedFiles.forEach(file => dataTransfer.items.add(file));
        $input[0].files = dataTransfer.files;
    }
});
